import doctorImg from '../assets/images/docter-profile.png';

export const clinicSpecialties = [
  'Cardiology',
  'Orthopedics',
  'Pediatrics',
  'Neurology',
  'Obstetrics & Gynecology',
  'Otorhinolaryngology',
  'Plastic & Reconstructive',
];

export const clinicDoctors = [
  {
    id: 1,
    name: 'Dr. Dominic Stonehart',
    role: 'Cardiologist | 15+ Years Experience',
    avatar: doctorImg,
    isOnline: true,
    country: 'India/Noida',
    date: '20/12/2025',
    time: '02:30 AM',
    totalSlots: 20,
    availableSlots: 18,
    waitingTime: '00:30:23',
  },
  {
    id: 2,
    name: 'Dr. Dominic Stonehart',
    role: 'Cardiologist | 15+ Years Experience',
    avatar: doctorImg,
    isOnline: true,
    country: 'India/Noida',
    date: '20/12/2025',
    time: '02:30 AM',
    totalSlots: 20,
    availableSlots: 18,
    waitingTime: '00:30:23',
  },
  {
    id: 3,
    name: 'Dr. Dominic Stonehart',
    role: 'Cardiologist | 15+ Years Experience',
    avatar: doctorImg,
    isOnline: false,
    country: 'India/Noida',
    date: '20/12/2025',
    time: '02:30 AM',
    totalSlots: 20,
    availableSlots: 18,
    waitingTime: '00:30:23',
  },
  {
    id: 4,
    name: 'Dr. Dominic Stonehart',
    role: 'Cardiologist | 15+ Years Experience',
    avatar: doctorImg,
    isOnline: true,
    country: 'India/Noida',
    date: '20/12/2025',
    time: '02:30 AM',
    totalSlots: 20,
    availableSlots: 18,
    waitingTime: '00:30:23',
  },
];
